import styled from"@emotion/styled";import{FlexLayout,mediaQuery}from"@wp/src/components/common/grid";export const SecurityDetailsContainer=styled(FlexLayout)`
  flex-wrap: nowrap;
  justify-content: flex-start;
`;export const BankSecurityListContainer=styled.div`
  margin-top: 16px;
  display: grid;
  ${mediaQuery({gridTemplateColumns:["1fr","1fr 1fr"]})}
  grid-gap: 16px;
`;